import type { v2, ControlTypeFunction } from '@sap/ux-specification-types';
import { ControlType } from '@sap/ux-specification-types';
import { syncRule, buildControlIdFromParent } from '../../../common/decoration';
import { addPatternForBindingChangeOfEnumOP, convertSectionId } from '../../../common';

/**
 * Create stable ID for Object Page Form Field.
 *
 * @param {string} baseId Base Id of the control
 * @param {string[]} _idBreadcrumbs - Breadcrumbs for internal processing (unused).
 * @param {string[]} breadcrumbs - Breadcrumbs representing the hierarchy of the control.
 * @param {ControlTypeFunction} _controlType - Function to determine the control type (unused).
 * @param {string} facetId - Title from the app schema (e.g., the facet ID).
 * @returns {string} stable ID of Object Page Form Action button
 */
const getSmartFieldControlId = (
    baseId: string,
    _idBreadcrumbs: string[],
    breadcrumbs: string[],
    _controlType: ControlTypeFunction,
    facetId: string
): string => {
    const convertedId = convertSectionId(breadcrumbs[1], facetId);
    const fieldCrumb = breadcrumbs.slice(-1)[0];
    const breadcrumbsTrail = [convertedId, fieldCrumb, 'GroupElement'];
    return buildControlIdFromParent(baseId, breadcrumbsTrail);
};

export class Field implements v2.Field {
    @syncRule({
        flex: {
            controlId: getSmartFieldControlId,
            controlType: (): ControlType => ControlType.GroupElement
        },
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible?: boolean;
}
